import { render } from "./OrderSucceed.vue?vue&type=template&id=e5d087dc"
import script from "./OrderSucceed.vue?vue&type=script&lang=js"
export * from "./OrderSucceed.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__